import { PlainTooltip } from "@similarweb/ui-components";

import { StyledSignalText, StyledSignalTextBold, StyledSignalTooltipText } from "./styles";

type NameStringWithTooltipProps = {
    names: string[];
    text: string;
};

const ITEMS_TO_SHOW_QUANTITY = 6;

const NameStringWithTooltip = ({ names, text }: NameStringWithTooltipProps) => {
    const firstNames = names.slice(0, ITEMS_TO_SHOW_QUANTITY);
    const firstNamesLength = firstNames.length;

    const lastNames = names.slice(ITEMS_TO_SHOW_QUANTITY);
    const firstNamesString =
        firstNamesLength <= ITEMS_TO_SHOW_QUANTITY
            ? ` ${firstNames.slice(0, firstNamesLength - 1).join(", ")} and ${firstNames[firstNamesLength - 1]}`
            : ` ${firstNames.join(", ")}`;

    return (
        <StyledSignalText>
            {text}
            {lastNames.length > 0 ? (
                <>
                    <span>{`${firstNamesString} and`}</span>
                    <PlainTooltip
                        enabled
                        maxWidth={250}
                        placement="top"
                        tooltipContent={
                            <>
                                {lastNames.map((name) => (
                                    <StyledSignalTooltipText key={name}>{name}</StyledSignalTooltipText>
                                ))}
                            </>
                        }
                    >
                        <StyledSignalTextBold>{` ${lastNames.length}\u00A0more`}</StyledSignalTextBold>
                    </PlainTooltip>
                </>
            ) : (
                firstNamesString
            )}
        </StyledSignalText>
    );
};

export default NameStringWithTooltip;
